import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showTopbarInsideAction } from "../../store/actions";
import withRouter from "../../components/Common/withRouter";
import NotFound from "../../components/Common/notFound";

const Error404 = (props) => {
  document.title = "Defender | Error 404";
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showTopbarInsideAction({}))
  }, [])

  return (
    <NotFound title={"Desculpe!"} subDescription={"A transação que procura não foi encontrada."} goBack={() => props.router.navigate(-1)}/>
  );
};

export default withRouter(Error404);
